import React, {Component} from 'react';
import AgGrid from '../AgGrid';
import {inject, observer} from 'mobx-react';

const columnDefs = [
    {headerName: "Row", valueGetter: "node.rowIndex + 1"},
    {headerName: "Division", field: "divisionName"},
    {headerName: "Abbreviation", field: "abbreviation"},
    {headerName: "Country", field: "country"},
    {headerName: "Document Title", field: "classification"},
    {headerName: "Author Name", field: "authorNames"},
    {headerName: "Recycle Period", field: "recyclePeriod"},
    {headerName: "Suggested Deadline Period", field: "deadlinePeriod"},
    {headerName: "Requested Date", field: "projectStartDate"},
    {headerName: "Suggested Deadline", field: "filesFromAuthorDate"},
    {headerName: "Last Updated Date", field: "lastUpdatedDate"},
];
@inject('looseLeafStore')
@observer
class LooseLeafList extends Component {

    componentDidMount() {
        this.fetchData();
    }

    get store() {
        return this.props.looseLeafStore;
    }

    render() {
        return (
            <div style={{
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                height: '100%'
            }}>
                <AgGrid
                    rowData={this.getRowData()}
                    columnDefs={columnDefs}
                    rowSelection={'single'}
                    onCellClicked={this.handleCellClicked}
                />
            </div>
        );
    }

    handleCellClicked = (params) => {

        const {data} = params;
        this.store.rowclick = false;
        this.store.updatedate = false;
        this.store.projectId =data.projectId;
        this.store.looseLeafSeed = data;
        this.store.updateLooseLeafSeedDefaultInfo();
        this.store.getCountryName = data.country;
        this.store.countryId = data.countryId;
        this.store.setDrawerVisible(true);
    };

    fetchData = () => {
        const store = this.props.looseLeafListStore;
        // eslint-disable-next-line default-case
        switch (this.props.context) {
            case 'active': {
                store.fetchActive();
                break;
            }
            case 'awaiting': {
                store.fetchAwaiting();
                break;
            }
            case 'planned': {
                store.fetchPlanned();
                break;
            }
        }
    };

    getRowData = () => {
        const store = this.props.looseLeafListStore;
        switch (this.props.context) {
            case 'active': {
                return store.activeSeeds;
            }
            case 'awaiting': {
                return store.awaitingSeeds;
            }
            case 'planned': {
                return store.plannedSeeds;
            }
        }
        return null;
    };

}

export default LooseLeafList;
